import React from 'react';

function OfflineCreatePOI(props) {
  const {
    show,
    onClose,
    poiName,
    setPoiName,
    selectedCategory,
    setSelectedCategory,
    selectedType,
    setSelectedType,
    localTypeColour,
    setLocalTypeColour,
    colourLocked,
    handleUnlockColour,
    shape,
    setShape,
    localLabelBorder,
    setLocalLabelBorder,
    localLabelBorderColour,
    setLocalLabelBorderColour,
    description,
    setDescription,
    iconFile,
    setIconFile,
    iconPreview,
    setIconPreview,
    poiImageFile,
    setPoiImageFile,
    poiImagePreview,
    setPoiImagePreview,
    fileInputRef,
    poiImageInputRef,
    savePOI,
    saveType,
    selectedTypeDisabled,
    customCategories,
    customTypes,
    imageUrl,
    categoryId,
    mapId,
  } = props;

  if (!show) return null;

  // Find the matching type for updating
  const matchingType = customTypes.find(
    t => t.name === selectedType && String(t.category_id) === String(categoryId)
  );

  // Convert iconFile to base64 string if present
  const getIconBase64 = () => {
    return new Promise(resolve => {
      if (!iconFile) return resolve(null);
      const reader = new FileReader();
      reader.onload = ev => resolve(ev.target.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(iconFile);
    });
  };

  const handleSaveClick = async () => {
    if (saveType && selectedType && categoryId && mapId) {
      const iconBase64 = await getIconBase64();

      const updatedType = {
        id: matchingType ? matchingType.id : Date.now(),
        map_id: mapId,
        category_id: categoryId,
        name: selectedType,
        color: localTypeColour,
        shape: shape,
        label_border: Number(localLabelBorder),
        label_bg_colour: localTypeColour, // assuming label bg uses the same color
        label_border_colour: localLabelBorderColour,
        icon: iconBase64 || (matchingType ? matchingType.icon : ""),
      };

      await saveType(updatedType);
    }

    // Save only POI specific fields; do not save style fields here
    await savePOI(poiName, imageUrl ? imageUrl.trim() : "", description);

    // Avoid dispatching events here to prevent premature re-render as per your design
  };

  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: 360,
        maxHeight: "80vh",
        overflowY: "auto",
        background: "#23242a",
        borderRadius: 16,
        boxShadow: "0 6px 24px #000b",
        padding: 12,
        color: "#fff",
        border: "1.5px solid #23252a",
        zIndex: 2002,
        display: "flex",
        flexDirection: "column",
      }}
      onClick={e => e.stopPropagation()}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 8,
          right: 10,
          background: "#444",
          color: "#fff",
          border: "none",
          borderRadius: 7,
          padding: "4px 9px",
          cursor: "pointer",
          zIndex: 2100,
        }}
      >
        ✕
      </button>
      <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 10 }}>
        Create New POI
      </div>
      <div style={{ marginBottom: 7 }}>
        <label>Name:</label>
        <br />
        <input
          type="text"
          value={poiName}
          onChange={e => setPoiName(e.target.value)}
          placeholder="Enter POI name (optional)"
          style={{ width: "100%" }}
        />
      </div>
      <div>
        <label>Category:</label>
        <br />
        <input
          type="text"
          value={selectedCategory}
          onChange={e => {
            setSelectedCategory(e.target.value);
            setSelectedType("");
          }}
          list="category-options"
          placeholder="Enter or select category"
          style={{ width: "100%" }}
        />
        <datalist id="category-options">
          {customCategories.map(cat => (
            <option
              key={String(cat.id || cat.name || cat)}
              value={cat.name ? String(cat.name) : String(cat)}
            />
          ))}
        </datalist>
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Type:</label>
        <br />
        <input
          type="text"
          value={selectedType}
          onChange={e => setSelectedType(e.target.value)}
          list={categoryId ? "type-options" : undefined}
          placeholder="Enter or select type"
          style={{ width: "100%" }}
        />
        {categoryId && (
          <datalist id="type-options">
            {customTypes
              .filter(t => String(t.category_id) === String(categoryId))
              .map(type => (
                <option
                  key={String(type.id || type.name || type)}
                  value={type.name ? String(type.name) : String(type)}
                />
              ))}
          </datalist>
        )}
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Type Colour:</label>
        <br />
        <input
          type="color"
          value={localTypeColour}
          onChange={e => setLocalTypeColour(e.target.value)}
          disabled={colourLocked}
          style={{ cursor: colourLocked ? "not-allowed" : "pointer" }}
        />
        {colourLocked && (
          <button
            type="button"
            onClick={handleUnlockColour}
            style={{
              marginLeft: 10,
              background: "#ffe670",
              color: "#181818",
              border: "none",
              borderRadius: 7,
              padding: "2px 10px",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Change Colour
          </button>
        )}
        <span style={{ marginLeft: 10, fontSize: 13, color: "#ffe670" }}>
          {localTypeColour.toUpperCase()}
        </span>
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Shape:</label>
        <br />
        <select
          value={shape}
          onChange={e => setShape(e.target.value)}
          style={{ width: "100%" }}
        >
          <option value="circle">Circle</option>
          <option value="square">Square</option>
          <option value="triangle">Triangle</option>
          <option value="star">Star</option>
        </select>
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Label Border:</label>
        <br />
        <select
          value={localLabelBorder}
          onChange={e => setLocalLabelBorder(Number(e.target.value))}
          style={{ width: "100%" }}
        >
          <option value={1}>Enabled</option>
          <option value={0}>Disabled</option>
        </select>
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Label Border Colour:</label>
        <br />
        <input
          type="color"
          value={localLabelBorderColour}
          onChange={e => setLocalLabelBorderColour(e.target.value)}
          style={{ width: "100%" }}
        />
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Description:</label>
        <br />
        <textarea
          rows="3"
          placeholder="e.g. Dog found in garage"
          value={description}
          onChange={e => setDescription(e.target.value)}
          style={{ width: "100%" }}
        />
      </div>
      <div style={{ marginTop: 7 }}>
        <label>Type Icon (PNG, max 256KB):</label>
        <br />
        <input
          type="file"
          accept="image/png"
          ref={fileInputRef}
          onChange={e => {
            const file = e.target.files[0];
            setIconFile(file || null);
            if (file) {
              const reader = new FileReader();
              reader.onload = ev => {
                setIconPreview(ev.target.result);
              };
              reader.readAsDataURL(file);
            } else {
              setIconPreview(null);
            }
          }}
          style={{ marginBottom: 6, width: "100%" }}
        />
        {iconPreview && (
          <div style={{ marginTop: 6 }}>
            <img
              src={iconPreview}
              alt="Icon preview"
              style={{
                width: 32,
                height: 32,
                background: "#222",
                border: "1px solid #999",
                borderRadius: 5,
              }}
            />
            <button
              type="button"
              onClick={() => {
                setIconFile(null);
                setIconPreview(null);
                if (fileInputRef.current) fileInputRef.current.value = "";
              }}
              style={{
                marginLeft: 15,
                background: "#f44c2b",
                color: "#fff",
                border: "none",
                borderRadius: 7,
                padding: "2px 8px",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              Remove
            </button>
          </div>
        )}
      </div>
      <div style={{ marginTop: 7 }}>
        <label>POI Image (PNG/JPG, max 1MB):</label>
        <br />
        <input
          type="file"
          accept="image/png, image/jpeg"
          ref={poiImageInputRef}
          onChange={e => {
            const file = e.target.files[0];
            setPoiImageFile(file || null);
            if (file) {
              const reader = new FileReader();
              reader.onload = ev => {
                setPoiImagePreview(ev.target.result);
              };
              reader.readAsDataURL(file);
            } else {
              setPoiImagePreview(null);
            }
          }}
          style={{ marginBottom: 6, width: "100%" }}
        />
        {poiImagePreview && (
          <div style={{ marginTop: 6 }}>
            <img
              src={poiImagePreview}
              alt="POI image preview"
              style={{
                width: 64,
                height: 64,
                background: "#222",
                border: "1px solid #999",
                borderRadius: 5,
              }}
            />
            <button
              type="button"
              onClick={() => {
                setPoiImageFile(null);
                setPoiImagePreview(null);
                if (poiImageInputRef.current) poiImageInputRef.current.value = "";
              }}
              style={{
                marginLeft: 15,
                background: "#f44c2b",
                color: "#fff",
                border: "none",
                borderRadius: 7,
                padding: "2px 8px",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              Remove
            </button>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        <button
          onClick={handleSaveClick}
          disabled={selectedTypeDisabled}
          style={{
            background: "#4cc153",
            color: "#fff",
            border: "none",
            borderRadius: 7,
            padding: "6px 18px",
            fontWeight: 700,
            fontSize: 16,
            cursor: "pointer",
            width: "100%",
          }}
        >
          Save POI
        </button>
      </div>
    </div>
  );
}

export default OfflineCreatePOI;
